import { render } from "./reindex.vue?vue&type=template&id=2f187525&scoped=true"
import script from "./reindex.vue?vue&type=script&lang=js"
export * from "./reindex.vue?vue&type=script&lang=js"

import "./reindex.vue?vue&type=style&index=0&id=2f187525&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f187525"]])

export default __exports__